import React, { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import { Terminal as XTerm } from "xterm"; 
import { FitAddon } from "xterm-addon-fit";
import "xterm/css/xterm.css";
import "./WebTerminal.css";

const WebTerminal = () => {
  const terminalRef = useRef(null);
  const term = useRef(null);
  const fitAddonRef = useRef(null);
  const socketRef = useRef(null);
  const [isOnline, setIsOnline] = useState(false);

  useEffect(() => {
    socketRef.current = io("https://streamsrv.n-tools.info/api", {
      transports: ["websocket", "polling"],
      reconnectionAttempts: 5,
    });

    const xterm = new XTerm({
      cursorBlink: true,
      fontSize: 14,
      fontFamily: "'Courier New', monospace",
      theme: {
        background: "#0d1117",
        foreground: "#00ff88",
      },
    });

    const fitAddon = new FitAddon();
    term.current = xterm;
    fitAddonRef.current = fitAddon;

    if (terminalRef.current) {
      xterm.loadAddon(fitAddon);
      xterm.open(terminalRef.current);
      
      setTimeout(() => {
        try { fitAddon.fit(); } catch (e) {}
      }, 500);

      // --- SMART PASTE: Right Click to Paste ---
      terminalRef.current.addEventListener('contextmenu', (e) => {
        e.preventDefault();
        navigator.clipboard.readText().then(text => {
          if (socketRef.current) socketRef.current.emit("input", text);
        });
      });
    }

    // --- SMART COPY: Auto-copy on selection ---
    xterm.onSelectionChange(() => {
      const selection = xterm.getSelection();
      if (selection) {
        navigator.clipboard.writeText(selection);
      }
    });

    // --- HANDLING KEYBOARD (Ctrl+V) ---
    xterm.attachCustomKeyEventHandler((event) => {
      // Allow Ctrl+V for pasting
      if (event.ctrlKey && event.key === 'v') {
        navigator.clipboard.readText().then(text => {
          socketRef.current.emit("input", text);
        });
        return false;
      }
      return true;
    });

    xterm.writeln("\x1b[32m[SYSTEM]\x1b[0m Establishing Secure SSH Tunnel...");

    const socket = socketRef.current;
    socket.on("connect", () => {
      setIsOnline(true);
      socket.emit("connect_terminal"); 
    });

    socket.on("output", (data) => {
      xterm.write(data);
    });

    socket.on("disconnect", () => {
      setIsOnline(false);
      xterm.writeln("\r\n\x1b[31m[DISCONNECTED]\x1b[0m Session ended.");
    });

    xterm.onData((data) => {
      if (socket.connected) {
        socket.emit("input", data);
      }
    });

    const handleResize = () => {
      try { if (fitAddonRef.current) fitAddonRef.current.fit(); } catch (err) {}
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      socket.disconnect();
      xterm.dispose();
    };
  }, []);

  return (
    <div className="terminal-container">
      <div className="terminal-header">
        <span>💻 WebTerminal</span>
        <div className="status-wrapper">
          <div className={`status-dot ${isOnline ? "online" : "offline"}`} />
          <span className="status-text">{isOnline ? "Online" : "Offline"}</span>
        </div>
      </div>
      <div className="terminal-body" ref={terminalRef} />
    </div>
  );
};

export default WebTerminal;
